/** 122593 Delete-blocking rule: the row's counts → confirm, or a blocked pop-up body (AC copy verbatim,
 *  grilling Q6). `assignedCustomerCount` is FE-proposed (F1) and reads as 0 while BE omits it. */
export type DealerDeleteCounts = { unassignedDeviceCount: number; assignedCustomerCount?: number };

export type DealerDeleteDecision =
  | { kind: 'confirm' }
  | { kind: 'blocked'; variant: 'customers' | 'devices' | 'both'; body: string };

export function decideDealerDelete({
  unassignedDeviceCount: m,
  assignedCustomerCount: n = 0,
}: DealerDeleteCounts): DealerDeleteDecision {
  if (n > 0 && m > 0)
    return {
      kind: 'blocked',
      variant: 'both',
      body: `${n} customers are assigned and ${m} devices are unassigned. Reassign the customers and assign the devices to delete this dealer.`,
    };
  if (n > 0)
    return {
      kind: 'blocked',
      variant: 'customers',
      body: `${n === 1 ? '1 customer is' : `${n} customers are`} assigned to this dealer. Reassign them to delete this dealer.`,
    };
  if (m > 0)
    return {
      kind: 'blocked',
      variant: 'devices',
      body:
        m === 1
          ? '1 device is unassigned. Assign it to delete this dealer.'
          : `${m} devices are unassigned. Assign them to delete this dealer.`,
    };
  return { kind: 'confirm' };
}
